import riitaj from "../../Assets/Departments/Mechanical/Ritij.jpeg";
import aditya from "../../Assets/Departments/Mechanical/Aditya.jpeg";
import harsh from "../../Assets/Departments/Mechanical/Harsh Kapse.jpeg";
import mayur from "../../Assets/Departments/Mechanical/Mayur wagh.jpeg";
import nayana from "../../Assets/Departments/Mechanical/Nayna Dhote.jpeg";
import sanchit from "../../Assets/Departments/Mechanical/Sanchit kasar.jpeg";
import vedant from "../../Assets/Departments/Mechanical/Vedant Dashmukhe.jpeg";
import sumedth from "../../Assets/Departments/Mechanical/Sumedh.jpeg";
import ganesh from "../../Assets/Departments/Mechanical/Ganesh deshmukh.jpeg";
import mohini from "../../Assets/Departments/Mechanical/Mohini.jpeg";
const members = [
    {
        name: "Sumedh Salvekar",
        imgurl: sumedth,
        branch: "MECH",
        year: "4th Year",
        linkedin: "https://www.linkedin.com/in/sumedhsalvekar",
        instagram: "https://www.instagram.com/sumedh2326/",
    },
    {
        name: "Mayur Wagh",
        imgurl: mayur,
        branch: "MECH",
        year: "4th Year",
        linkedin: "https://www.linkedin.com/in/mayurgwagh",
        instagram: "",
    },
    {
        name: "Ganesh Deshmukh",
        imgurl: ganesh,
        branch: "MECH",
        year: "4th Year",
        linkedin: "https://www.linkedin.com/in/ganesh-deshmukh-mechanicalengineer",
        instagram: "https://www.instagram.com/ganesh.deshmukh4028/",
    },
    {
        name: "Harsh Kapse",
        imgurl: harsh,
        branch: "MECH",
        year: "3rd Year",
        linkedin: "https://www.linkedin.com/in/harsh-kapse-216748192",
        instagram: "https://www.instagram.com/_harshkapse/",
    },
    {
        name: "Mohini Kulkarni",
        imgurl: mohini,
        branch: "MECH",
        year: "3rd Year",
        linkedin: "https://www.linkedin.com/in/mohini-kulkarni-39239a199",
        instagram: "",
    },
    {
        name: "Vedant Dashmukhe",
        imgurl: vedant,
        branch: "MECH",
        year: "2nd Year",
        linkedin: "https://www.linkedin.com/in/vedant-dashmukhe-8772a2214",
        instagram: "",
    },
    {
        name: "Nayana Dhote ",
        imgurl: nayana,
        branch: "MECH",
        year: "2nd Year",
        linkedin: "https://www.linkedin.com/in/nayana-dhote-9a63761b8",
        instagram: "",
    }, 
    {
        name: "Aditya Magdum",
        imgurl: aditya,
        branch: "MECH",
        year: "2nd Year",
        linkedin: "https://www.linkedin.com/in/vedant-dashmukhe-8772a2214",
        instagram: "",
    },
    {
        name: "Riitaj Thakur",
        imgurl: riitaj,
        branch: "MECH",
        year: "2nd Year",
        linkedin: "https://www.linkedin.com/mwlite/in/riitaj-thakur-755b5a219",
        instagram: "",
    },
    
    
    {
        name: "Sanchit kasar",
        imgurl: sanchit,
        branch: "MECH",
        year: "2nd Year",
        linkedin: "https://www.linkedin.com/in/sanchit-kasar-642b031b9",
        instagram: "https://www.instagram.com/mr_sanchit_.sk_/",
    },
    
    
    
    
]
export default members
//   {
//     name: "Sumedh Salvekar",
//     imgurl: sumedth,
//     branch: "MECH",
//     year: "4nd Year",
//     linkedin: "https://www.linkedin.com/in/sumedhsalvekar",
//     instagram: "https://www.instagram.com/sumedh2326/",
//   },
//   {
//     name: "Ganesh Deshmukh",
//     imgurl: ganesh,
//     branch: "MECH",
//     year: "4th Year",
//     linkedin: "https://www.linkedin.com/in/ganesh-deshmukh-mechanicalengineer",
//     instagram: "https://www.instagram.com/ganesh.deshmukh4028/",
//   },
//   {
//     name: "Harsh Kapse",
//     imgurl: harsh,
//     branch: "MECH",
//     year: "3rd Year",
//     linkedin: "https://www.linkedin.com/in/harsh-kapse-216748192",
//     instagram: "https://www.instagram.com/_harshkapse/",
//   },
//   {
//     name: "Mohini Kulkarni",
//     imgurl: mohini,
//     branch: "ENTC",
//     year: "3rd Year",
//     linkedin: "https://www.linkedin.com/in/mohini-kulkarni-39239a199",
//     instagram: "",
//   },
//   {
//     name: "Vedant Dashmukhe",
//     imgurl: vedant,
//     branch: "MECH",
//     year: "2nd Year",
//     linkedin: "https://www.linkedin.com/in/vedant-dashmukhe-8772a2214",
//     instagram: "",
//   },
//   {
//     name: "Nayana Dhote ",
//     imgurl: nayana,
//     branch: "MECH",
//     year: "2nd Year",
//     linkedin: "https://www.linkedin.com/in/nayana-dhote-9a63761b8",
//     instagram: "",
//   },
//   {
//     name: "Mayur Wagh",
//     imgurl: mayur,
//     branch: "MECH",
//     year: "2nd Year",
//     linkedin: "https://www.linkedin.com/in/mayurgwagh",
//     instagram: "",
//   },
//   {
//     name: "Aditya Magdum",
//     imgurl: aditya,
//     branch: "MECH",
//     year: "2nd Year",
//     linkedin: "https://www.linkedin.com/in/vedant-dashmukhe-8772a2214",
//     instagram: "",
//   },
//   {
//     name: "Riitaj Thakur",
//     imgurl: riitaj,
//     branch: "MECH",
//     year: "2nd Year",
//     linkedin: "https://www.linkedin.com/mwlite/in/riitaj-thakur-755b5a219",
//     instagram: "",
//   },

//   {
//     name: "Sanchit kasar",
//     imgurl: sanchit,
//     branch: "MECH",
//     year: "2nd Year",
//     linkedin: "https://www.linkedin.com/in/sanchit-kasar-642b031b9",
//     instagram: "https://www.instagram.com/mr_sanchit_.sk_/",
//   },
// ];
// export default members;
